<template lang="html">
  <div class="real-estate">
    <div v-if="translationsLoaded">
      <masterdata-ui
        :columns="columns" :grid-title="SR_RealEstate.Currency"
        :modal-title-add="SR_RealEstate.AddCurrency" :modal-title-edit="SR_RealEstate.EditCurrency"
        :load-items-action-url="loadItemsActionUrl" :update-item-action-url="updateItemActionUrl"
        :create-item-action-url="createItemActionUrl"
        :build-object-for-request="buildCurrencyObject" :setup-modal-content="setupModalContent"
      />
    </div>
  </div>
</template>

<script lang="js">
import makeResourceMixin from 'src/vue/mixins/make-resource-mixin'
import masterdataUi from './masterdata-ui'
import newGuid from 'src/js/helpers/new-guid'

const resources = {
  SR_RealEstate: 'Areas.RealEstate.SR_RealEstate'
}

export default {
  components: {
    masterdataUi
  },
  mixins: [makeResourceMixin(resources)],

  data () {
    return {
      loadItemsActionUrl: '/RealEstate/MasterDataCurrency/GetCurrencies',
      updateItemActionUrl: '/RealEstate/MasterDataCurrency/Update',
      createItemActionUrl: '/RealEstate/MasterDataCurrency/Create',
      translationsLoaded: false
    }
  },

  computed: {
    columns () {
      return [
        {
          localizedTitle: this.SR_RealEstate['CurrencyName'],
          typeName: 'String',
          propertyName: 'name'
        },
        {
          localizedTitle: this.SR_RealEstate['CurrencyShortcut'],
          typeName: 'String',
          propertyName: 'short'
        },
        {
          localizedTitle: 'UID',
          typeName: 'String',
          propertyName: 'uid',
          isIdColumn: true,
          invisible: true
        }
      ]
    }
  },

  methods: {

    setupModalContent (data = {uid: newGuid(), name: '', short: ''}) {
      return [
        {propertyName: 'uid', value: data.uid, label: '', required: false, editable: false},
        {propertyName: 'name', value: data.name, label: this.SR_RealEstate.CurrencyName, required: true, editable: true},
        {propertyName: 'short', value: data.short, label: this.SR_RealEstate.CurrencyShortcut, required: true, editable: true}
      ]
    },

    buildCurrencyObject (data) {
      return {
        uid: data[0].value, // TODO: find better solution
        name: data[1].value,
        short: data[2].value
      }
    }
  },
  created () {
    this.$store.dispatch('i18n/preloadTranslations', [
      'Areas.RealEstate.SR_RealEstate'
    ])
      .then(() => {
        this.translationsLoaded = true
      })
  }
}
</script>

<style lang="scss" scoped>
</style>
